import { render, staticRenderFns } from "./PartyOnboardingContact.vue?vue&type=template&id=cd48b3e6"
import script from "./PartyOnboardingContact.vue?vue&type=script&lang=js"
export * from "./PartyOnboardingContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports